import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { SKIP_REALM_HEADER } from "@shared/consts/skip-realm-header.const";

export const realmInterceptor: HttpInterceptorFn = (req, next) =>
{
    if (req.context.get(SKIP_REALM_HEADER)) return next(req)

    const router = inject(Router)

    const urlSegments = router.url.split('/')
    const realm = urlSegments[1]

    const modifiedReq = req.clone({
        setHeaders: { 'X-Realm': realm }
    })

    return next(modifiedReq)
}
